module.exports = __webpack_public_path__ + "img/slide-1-ua.e926c2b6.png";